"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormDeleteConfirmModal = void 0;
const modal_form_component_1 = require("../../components/modal.form/modal.form.component");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
class FormDeleteConfirmModal extends modal_form_component_1.ModalFormComponent {
    constructor(ctx, formSummary) {
        super(ctx);
        this.formSummary = formSummary;
    }
    get nodes() {
        return (0, mithril_1.m)('p', (0, i18n_1.Translate)(i18n_1.T.FORM_DELETE_CONFIRM, { name: this.formSummary.displayname }));
    }
    submit() {
        return services_1.Services.Form.remove(this.formSummary.uuid);
    }
}
exports.FormDeleteConfirmModal = FormDeleteConfirmModal;
//# sourceMappingURL=form.delete.confirm.modal.js.map